import React, { FC, ReactNode } from "react";
import { LinkStyled } from "./style";
import { ExportDataDelimited } from '@fundacao/shared-components/esm/ie/renovacao/index';
import { UseCampanhaContext } from "context/campanha-context";

interface DefaultFileModalProps {
    onModal?: boolean;
    children: ReactNode;
}

const DefaultFileLink: FC<DefaultFileModalProps> = ({ children, onModal }) => {

    const { setDefaultFileModalOpen } = UseCampanhaContext();

    const generateFileDownload = () => {

        const defaultFileContent = [{
            Nome: 'Exemplo',
            'E-mail': 'exemplo@exemplo.com.br',
            Telefone: '55(99)99999-9999'
        }]


        ExportDataDelimited.toCSV(
            defaultFileContent,
            'csv',
            `arquivo-padrao-campanhas-${new Date().getTime()}`,
        );
    }

    const handleClick = () => {
        if (onModal) {
            generateFileDownload();
        }
        else {
            setDefaultFileModalOpen(true);
            generateFileDownload();
        }
    }

    return (
        <LinkStyled
            onClick={handleClick}
        >
            {children}
        </LinkStyled>


    )
}

export default DefaultFileLink;